<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts';
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

const animationDuration = 6000

export default {
  mixins: [resize],
  props: {
    barData: {
      type: Array,
    },
    xdata: {
      type: Array,
    },
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    }, 
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(()=>{
        this.initChart()
      },500)
      
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: `{b}: {c} 吨`
        },
        backgroundColor: 'transparent',
        xAxis: [{
          type: 'category',
          data: this.xdata,
          axisLine: {
            lineStyle: {
              color: '#E1E6E6' // 设置X轴颜色
            }
          },
          axisLabel: {
            interval: 0, // 强制显示所有标签
            rotate: -45, // 旋转角度，这里设置为 -90 度（逆时针旋转 90 度）
            align: 'left', // 对齐方式，设置为左对齐
            verticalAlign:'middle' // 垂直对齐方式
          }
        },
       ],
        yAxis: [{
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color:'#E1E6E6'// 设置Y轴颜色
            },   
          }, 
          axisLabel: {
            formatter:  `{value} 吨`
          },
          splitLine: {
              show: false // 隐藏 Y 轴的分隔线
          },
          splitArea: {
            show: false
          }
        }],
        legend: {
          data: this.barData.map(item => item.name),
          textStyle:{
            color: '#E1E6E6'
          }
        },
        series: [{
          name: '可回收物',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: this.barData[0].data,
          animationDuration
        }, {
          name: '其他',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: this.barData[1].data,
          animationDuration
        }],

      })
    }
  }
}
</script>
